module.exports = __webpack_public_path__ + "img/Technicien-ne-en-salle-doperation-1024x683.8e989672.jpg";